"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _reactDom = require("react-dom");

var _nodeIds = require("../../constants/nodeIds");

var _StepIcon = _interopRequireDefault(require("./StepIcon"));

var _StepConnector = _interopRequireDefault(require("./StepConnector"));

var _StepLabel = _interopRequireDefault(require("./StepLabel"));

var StyledStep = (0, _styles.withStyles)(function () {
  return (0, _material.createStyles)({
    root: {}
  });
})(_material.Step);
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    baseStepper: {
      padding: spacing(2),
      backgroundColor: palette.background.darken
    }
  };
});

var Stepper = function Stepper(_ref2) {
  var _steps$activeStepIdx;

  var activeStep = _ref2.activeStep,
      children = _ref2.children,
      header = _ref2.header,
      muiStepperProps = (0, _objectWithoutProperties2.default)(_ref2, ["activeStep", "children", "header"]);
  var classes = useStyles();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      outletElement = _useState2[0],
      setOutletElement = _useState2[1];

  var steps = (0, _react.useMemo)(function () {
    return children.map(function (element) {
      return {
        name: element.props.name,
        label: element.props.label,
        children: element
      };
    });
  }, [children]);
  var activeStepIdx = (0, _react.useMemo)(function () {
    return steps.findIndex(function (step) {
      return step.name === activeStep;
    });
  }, [steps, activeStep]);
  (0, _react.useEffect)(function () {
    var timer = setInterval(function () {
      var nextOutletElement = document.getElementById(_nodeIds.STEPPER_OUTLET_ID);

      if (outletElement !== nextOutletElement) {
        setOutletElement(nextOutletElement);
      }
    }, 300);
    return function () {
      clearInterval(timer);
    };
  }, [outletElement]);

  var stepper = /*#__PURE__*/_react.default.createElement(_material.Stepper, (0, _extends2.default)({
    className: classes.baseStepper,
    activeStep: activeStepIdx,
    alternativeLabel: true,
    connector: /*#__PURE__*/_react.default.createElement(_StepConnector.default, null)
  }, muiStepperProps), steps.map(function (step) {
    return /*#__PURE__*/_react.default.createElement(StyledStep, {
      key: step.name
    }, /*#__PURE__*/_react.default.createElement(_StepLabel.default, {
      StepIconComponent: _StepIcon.default
    }));
  }));

  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    height: 1,
    display: "flex",
    flexDirection: "column"
  }, header, !outletElement && stepper, outletElement && /*#__PURE__*/(0, _reactDom.createPortal)(stepper, outletElement), (_steps$activeStepIdx = steps[activeStepIdx]) === null || _steps$activeStepIdx === void 0 ? void 0 : _steps$activeStepIdx.children);
};

var _default = Stepper;
exports.default = _default;